import {ElasticValidation, ElasticValidator} from '../validator.factory';
import {
  galacticNoRangeRegExp,
  galacticRangeRegExp,
  LongitudeLatitudeToRaDegDegreesFormatter
} from '../../paser/parsers/galatic.parser';
import {NumberValidator} from './number.validator';
import {defaultRaDecRadius} from '../../paser/parsers/ra-dec.parser';
import {RaDecValidator} from './ra-dec.validator';

export class GalacticValidator implements ElasticValidator {
  validate(galacticString: string): ElasticValidation {
    if (galacticString === undefined || galacticString === null || galacticString === '') {
      return {isInvalid: false};
    }

    galacticString = galacticString.trim();
    if (galacticString === '') {
      return {isInvalid: true, errorMessage: `blanks are not allowed`};
    }

    const isGalacticStringAGalacticRangeRegExp = galacticRangeRegExp.test(galacticString);
    const isGalacticStringAGalacticNoRangeRegExp = galacticNoRangeRegExp.test(galacticString);

    if (isGalacticStringAGalacticRangeRegExp) {
      return this.validateGalacticRangeRegExp(galacticString);
    } else if (isGalacticStringAGalacticNoRangeRegExp) {
      return this.validateGalacticStringAGalacticNoRangeRegExp(galacticString);
    } else {
      return {isInvalid: true, errorMessage: `${galacticString} is not valid position`};
    }
  }

  private validateGalacticRangeRegExp(galacticString): any {
    const match = galacticRangeRegExp.exec(galacticString);

    const indexLongitudeRangeInMatches = 1;
    const indexLatitudeRangeInMatches = 22;

    const longitudeString = match[indexLongitudeRangeInMatches];
    const latitudeString = match[indexLatitudeRangeInMatches];

    const longitudeNumberValidator = new NumberValidator();
    const latitudeNumberValidator = new NumberValidator();

    const longitudeNumberValidation = longitudeNumberValidator.validate(longitudeString);
    const latitudeNumberValidation = latitudeNumberValidator.validate(latitudeString);

    if (longitudeNumberValidation.isInvalid) {
      return longitudeNumberValidation;
    } else if (latitudeNumberValidation.isInvalid) {
      return latitudeNumberValidation;
    } else {
      return {isInvalid: false};
    }
  }

  private validateGalacticStringAGalacticNoRangeRegExp(galacticString): any {
    const match = galacticNoRangeRegExp.exec(galacticString);

    const indexLongitudeInMatches = 1;
    const indexLatitudeInMatches = 5;
    const indexRadiusInMatches = 9;

    const longitudeString = match[indexLongitudeInMatches];
    const latitudeString = match[indexLatitudeInMatches];
    const radiusString = match[indexRadiusInMatches];

    const longitudeNumeric = +longitudeString;
    const latitudeNumeric = +latitudeString;
    const radiusNumeric = +radiusString?.replace(',', '') || defaultRaDecRadius;

    const longitudeLatitudeToRaDegDegreesFormatter = new LongitudeLatitudeToRaDegDegreesFormatter();
    const {ra, dec} = longitudeLatitudeToRaDegDegreesFormatter.apply(longitudeNumeric, latitudeNumeric);

    const galacticRaDecValidator = new RaDecValidator();
    const galacticInRaDecRadiusFormat = `${ra} ${dec}, ${radiusNumeric}`;

    return galacticRaDecValidator.validate(galacticInRaDecRadiusFormat);
  }
}
